import { useTranslation } from 'react-i18next';

import { GetPurchaseDetailsQuery as GetPurchaseDetails } from '__generated__/graphql';
import UI from '../../../../common/UI';
import useLocale from '../../../../common/useLocale';

type Purchase = GetPurchaseDetails['project']['purchase'];

export interface PurchaseInfoProps {
  purchase: Purchase;
}

const PurchaseInfo = ({ purchase }: PurchaseInfoProps) => {
  const { t } = useTranslation();
  const { formatDate, parseDate } = useLocale();

  const { registration } = purchase;

  return (
    <UI.Card sc={{ spacing: 'sm', background: 'white', outline: 'gray.150', borderRadius: 'md' }}>
      <UI.FormGrid sc={{ columns: '1fr fit-content(150px)', gutter: 0.5, alignVertical: 'center' }}>
        <UI.Div>
          <UI.Div sc={{ strong: true }}>
            {purchase.ticket?.title || purchase.product?.title}
          </UI.Div>
          <UI.Div sc={{ small: true }}>
            {t('order')}
            {' '}
            {purchase.order.invoice_id}
          </UI.Div>
        </UI.Div>
        {registration && (
          <UI.Div sc={{ small: true, textAlign: 'right', mt: 0.5 }}>
            <UI.Div sc={{ fontWeight: 500 }}>
              ATL
              {registration.sequence}
            </UI.Div>
            <UI.Div sc={{ muted: true }}>
              {formatDate(
                parseDate(registration.created_at, { timezone: 'UTC' }),
                { format: 'display_compact_date' },
              )}
            </UI.Div>
          </UI.Div>
        )}
      </UI.FormGrid>
    </UI.Card>
  );
};

export default PurchaseInfo;
